module.exports = __webpack_public_path__ + "static/media/hollow_bar.df0394e0.svg";